import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { IDciViewInputModel } from "src/app/ViewModel/DCIViewModels";
import { IDocSLNoInputModel } from "src/app/ViewModel/DocumentModel";
import { IPorjectInputModel, IScheduleElementDetails, IDCIDocumentOutputModel, GetSDListforGrid } from "src/app/ViewModel/ScheduleDefinitionModel";
import { IScheduleDocDetails, IScheduleDocModel, IScheduleDocRevModel, IScheduleDocStageDetails, IScheduleMHDetails, IScheduleWFPlanDetails, IScheduleWorkflowDetails, IScheduleDocApprovalDetails, SDLinkModel, IScheduleBulkInsertModel, DCIToStartWorkflow_Input, WFTransmittalInputModel, IDciWFStageDetails, IDCISupersedeRevDetailsModel, IDCIPostWorkflowSupersedeModel, IScheduleDateUpdateDetails, IDCISupersedeRevInputModel, IDCISupersedeRevWFInputModel, IDeleteWorkflowInputModel, IWBSInputModel, IDeliverableInputModel, IWBSOutputModel, ICPCInputModel, ISDInputModel, ISDOutputModel, IDCIPostBulkSupersedeModel } from "src/app/ViewModel/ScheduleDocumentModel";
import { RestApiService } from "../rest-api.service";
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { CommonService } from '../Common.service';
import { EncryptDecryptService } from '../encrypt-decrypt.service';

@Injectable({
    providedIn: 'root'
})
export class ScheduleDocumentService {
    private endPoints = {
        getDciSerialNo: 'DCIDocument/GetDCIDocSerialNo',
        insertBulkSchDoc: 'DCIDocument/InsertBulkDciDocument',
        insertBulkISODCIDoc: 'DCIDocument/InsertISOBulkDCIDocuments',
        insertUpdateScheduleDoc: 'DCIDocument/InsertUpdateDCIDocument',
        insertUpdateScheduleDocEleDetails: 'DCIDocument/InsertUpdateDCIDocumentElementDetails',
        insertUpdateScheduleRev: 'DCIDocument/InsertUpdateDCIDocumentRevision',
        insertUpdateSchWFPlanDetails: 'DCIDocument/InsertUpdateDCIDocumentScheduleWFPlanDetails',
        insertUpdateSchDocStageDetails: 'DCIDocument/InsertUpdateDCIDocumentScheduleStageDetails',
        insertUpdateMHDetails: 'DCIDocument/InsertUpdateDCIDocumentScheduleMHDetails',
        insertUpdateSchDetails: 'DCIDocument/InsertUpdateDCIDocumentScheduleDetails',
        insertUpdateSchWorkflowDetails: 'DCIDocument/InsertUpdateDCIDocumentScheduleWorkflowDetails',
        getScheduleDocList: 'DCIDocument/GetDCIDocumentListDetails',
        getStdDciListForGrid: 'DCIDocument/GetStdDciListForGrid',
        insertUpdateSchApprovalDetails: 'DCIDocument/InsertUpdateDCIDocumentScheduleApprovalDetails',
        getDciDocumentViewDetails: "DCIDocument/GetDCIDocumentViewDetails",
        getDciExcelTemplate: "/DCIDocument/DownloadDCITemplate",
        uploadDciExcelTemplate: "/DCIDocument/UploadDCITemplate",
        fetchISODCIDetails: "/DCIDocument/FetchISODCIDetails",
        getWorkflowList: "WorkflowTemplate/GetWorkflowTemplateList",
        getStartWorkflowDetails: "WorkflowTransaction/GetStartWorkflowDetails",
        postStartWorkflowDetails: "WorkflowTransaction/PostStartWorkflowDetails",
        getworkflowhistory: "WorkflowTransaction/GetWorkflowHistoryList",
        getWorkflowPendingDocuments: "DCIDocument/GetDCIWorkflowPendingDocuments",
        getWorkflowTransmittalStatus: "DCIDocument/GetDCIWorkflowTransmittalStatus",
        postWorkflowSupersede: "WorkflowTransaction/PostWorkflowSupersede",
        postsupersedeStdDraw: "WorkflowTransaction/PostStdDrawSupersede",
        getWorkflowStageDetails: "DCIDocument/GetWorkflowStageDetails",
        updateSupersedeRevDetails: "DCIDocument/UpdateDCISupersedeRevDetails",
        getSupersedeRevDetails: "DCIDocument/GetDCISupersedeRevDetails",
        updateSupersedeRevWFDetails: "DCIDocument/UpdateDCISupersedeRevWorkflowDetails",
        updateScheduleDateToDocuments: 'DCIDocument/UpdateScheduleDateToDocuments',
        DeleteWorkflowstep: 'RepositoryDocuments/DeleteWorkflowstep',
        getWBSCodes: "DCIDocument/GetWBSCodes",
        getDeliverableCodes: "DCIDocument/GetDeliverableCodes",
        insertCPCDocDetails: "DCIDocument/InsertCPCDocDetails",
        getStandardDrawings: "DCIDocument/GetStandardDrawings",
        insertStdDwgDocument: 'DCIDocument/InsertStdDwgDocument',
        linkStdDciDoc: 'DCIDocument/LinkStdDciDoc',
        getSDDocList: 'DCIDocument/GetDCISDDocumentListDetails',
        PostBulkDCISupersede: 'WorkflowTransaction/PostBulkDCISupersede'

    }
    constructor(private encryptDecryptService: EncryptDecryptService, private restAPIService: RestApiService, private http: HttpClient, private commonService: CommonService) { }

    /**
    * Generate Serial No based on DCI Document Element Details
    * @param DocSLNo
    */
    public GetDocSerialNo(docInputModel: IDocSLNoInputModel): Observable<any> {
        return this.restAPIService.new_POST(this.endPoints.getDciSerialNo, docInputModel);
    }

    public InsertScheduleBulkDocument(schBulkDoc: IScheduleBulkInsertModel) {
        return this.restAPIService.new_POST(this.endPoints.insertBulkSchDoc, schBulkDoc);
    }

    public InsertUpdateScheduleDocument(schDocInput: IScheduleDocModel): Observable<any> {
        return this.restAPIService.new_POST(this.endPoints.insertUpdateScheduleDoc, schDocInput);
    }

    public InsertUpdateDCIDocumentElementDetails(schDocElementDetails: IScheduleElementDetails): Observable<any> {
        return this.restAPIService.new_POST(this.endPoints.insertUpdateScheduleDocEleDetails, schDocElementDetails);
    }

    public InsertUpdateDCIRevision(scheduleDocRevision: IScheduleDocRevModel): Observable<any> {
        return this.restAPIService.new_POST(this.endPoints.insertUpdateScheduleRev, scheduleDocRevision);
    }

    public InsertUpdateScheduleWFPlanDetails(scheduleDocWFPlandetails: IScheduleWFPlanDetails): Observable<any> {
        return this.restAPIService.new_POST(this.endPoints.insertUpdateSchWFPlanDetails, scheduleDocWFPlandetails)
    }

    public InsertUpdateScheduleDocStageDetails(scheduleDocStageDetails: IScheduleDocStageDetails): Observable<any> {
        return this.restAPIService.new_POST(this.endPoints.insertUpdateSchDocStageDetails, scheduleDocStageDetails)
    }

    public InsertUpdateScheduleMHDetails(scheduleDocMHDetails: IScheduleMHDetails): Observable<any> {
        return this.restAPIService.new_POST(this.endPoints.insertUpdateMHDetails, scheduleDocMHDetails)
    }

    public InsertUpdateScheduleDetails(scheduleDocDetails: IScheduleDocDetails): Observable<any> {
        return this.restAPIService.new_POST(this.endPoints.insertUpdateSchDetails, scheduleDocDetails)
    }

    public InsertUpdateScheduleWorkflowDetails(scheduleWorkflowDetails: IScheduleWorkflowDetails): Observable<any> {
        return this.restAPIService.new_POST(this.endPoints.insertUpdateSchWorkflowDetails, scheduleWorkflowDetails)
    }

    public GetScheduleDocList(input: IPorjectInputModel): Observable<any> {
        input.requestedBy = this.commonService.getLoggedInUserId();
        return this.restAPIService.new_POST(this.endPoints.getScheduleDocList, input)
    }

    public GetStdDciListForGrid(getSDinput: GetSDListforGrid): Observable<any> {
        return this.restAPIService.new_POST(this.endPoints.getStdDciListForGrid, getSDinput)
    }

    public InsertUpdateScheduleApprovalDetails(scheduleApprovalDetails: IScheduleDocApprovalDetails): Observable<any> {
        return this.restAPIService.new_POST(this.endPoints.insertUpdateSchApprovalDetails, scheduleApprovalDetails)
    }

    public GetDCIDocumentViewDetails(dciViewInput: IDciViewInputModel): Observable<any> {
        return this.restAPIService.new_POST(this.endPoints.getDciDocumentViewDetails, dciViewInput);
    }

    public GetDCIExcelTemplate(dciExcelInput: IPorjectInputModel): Observable<Blob> {
        let _apiURL = environment.uriHost + this.endPoints.getDciExcelTemplate;
        const headers = {
            'X-Requested-With': 'XMLHttpRequest',
            'Authorization': 'Bearer ' + this.commonService.getJWT(),
            'loginAuditNumber': this.encryptDecryptService.decrypt(this.commonService.getLoginAuditNumber())
        }
        return this.http.post(_apiURL, dciExcelInput, { 'headers': headers, responseType: 'blob' });
    }

    public UploadDCIExcelTemplate(formData: FormData): Observable<any> {
        let _apiURL = environment.uriHost + this.endPoints.uploadDciExcelTemplate;
        const headers = {
            'X-Requested-With': 'XMLHttpRequest',
            'Authorization': 'Bearer ' + this.commonService.getJWT(),
            'loginAuditNumber': this.encryptDecryptService.decrypt(this.commonService.getLoginAuditNumber())
        }
        return this.http.post<any>(_apiURL, formData, { 'headers': headers });
    }

    public GetWorkflowList(): Observable<any> {
        let reqData = {
            projectId: this.commonService.getProjectId(),
            groupId: this.commonService.getLoggedInUserGroupId()
        }
        return this.restAPIService.new_POST(this.endPoints.getWorkflowList, reqData);
    }

    public GetStartWorkflowDetails(DCIWFMapping: any): Observable<any> {
        let reqData = {
            projectId: this.commonService.getProjectId(),
            groupId: this.commonService.getLoggedInUserGroupId(),
            workflowId: DCIWFMapping.filter((y: { workflowId: number; }) => y.workflowId != 0)[0]["workflowId"],
            startWFInputModel: DCIWFMapping
        }
        return this.restAPIService.new_POST(this.endPoints.getStartWorkflowDetails, reqData);
    }

    public PostStartWorkflowDetails(DCIWFMapping: any, memberInput: any): Observable<any> {
        let reqData = {
            projectId: this.commonService.getProjectId(),
            groupId: this.commonService.getLoggedInUserGroupId(),
            workflowId: DCIWFMapping.filter((y: { workflowId: number; }) => y.workflowId != 0)[0]["workflowId"],
            startWFSaveInputModel: memberInput,
            createdBy: this.commonService.getLoggedInUserId()
        }
        return this.restAPIService.new_POST(this.endPoints.postStartWorkflowDetails, reqData);
    }

    public getWorkflowHistory(docId: number,taskID?: number): Observable<any> {
        let reqData = {
            documentId: docId,
            taskId:taskID,
            projectId: this.commonService.getProjectId(),
            groupId: this.commonService.getLoggedInUserGroupId()
        }
        return this.restAPIService.new_POST(this.endPoints.getworkflowhistory, reqData);
    }

    public PostWorkflowSupersede(dciPostWorkflowSupersede: IDCIPostWorkflowSupersedeModel): Observable<any> {
        return this.restAPIService.new_POST(this.endPoints.postWorkflowSupersede, dciPostWorkflowSupersede);
    }

    public PostSupersedeStdDraw(obj:any):Observable<any> {
        return this.restAPIService.new_POST(this.endPoints.postsupersedeStdDraw, obj);
    }

    public PostBulkDCISupersede(DCIPostBulkSupersedeModel: IDCIPostBulkSupersedeModel[]): Observable<any> {

        let reqData = {
            UserId: this.commonService.getLoggedInUserId(),
            jsonFinalBulkDCISupersedeDetails: DCIPostBulkSupersedeModel
        }
        return this.restAPIService.new_POST(this.endPoints.PostBulkDCISupersede, reqData);
    }

    public GetWorkflowPendingDocuments(input: IPorjectInputModel): Observable<any> {
        return this.restAPIService.new_POST(this.endPoints.getWorkflowPendingDocuments, input)
    }

    public GetWorkflowTransmittalStatus(input: WFTransmittalInputModel): Observable<any> {
        return this.restAPIService.new_POST(this.endPoints.getWorkflowTransmittalStatus, input)
    }

    public GetWorkflowStageDetails(input: IDciWFStageDetails): Observable<any> {
        return this.restAPIService.new_POST(this.endPoints.getWorkflowStageDetails, input);
    }

    public UpdateSupersedeRevisionDetails(input: IDCISupersedeRevDetailsModel) {
        return this.restAPIService.new_POST(this.endPoints.updateSupersedeRevDetails, input)
    }

    public GetSupersedeRevisionDetails(input: IDCISupersedeRevInputModel) {
        return this.restAPIService.new_POST(this.endPoints.getSupersedeRevDetails, input)
    }

    public UpdateSupersedeRevisionWFDetails(input: IDCISupersedeRevWFInputModel) {
        return this.restAPIService.new_POST(this.endPoints.updateSupersedeRevWFDetails, input)
    }

    public UpdateScheduleDateToDocuments(scheduleDateUpdate: IScheduleDateUpdateDetails): Observable<any> {
        return this.restAPIService.new_POST(this.endPoints.updateScheduleDateToDocuments, scheduleDateUpdate)
    }
    public DeleteOrUpdateWorkflow(Input: IDeleteWorkflowInputModel): Observable<any> {
        return this.restAPIService.new_POST(this.endPoints.DeleteWorkflowstep, Input)
    }

    public GetWBSCodes(input: IWBSInputModel): Observable<IWBSOutputModel> {
        return this.restAPIService.new_POST(this.endPoints.getWBSCodes, input);
    }

    public GetDeliverableCodes(input: IDeliverableInputModel): Observable<any> {
        return this.restAPIService.new_POST(this.endPoints.getDeliverableCodes, input);
    }

    public InsertCPCDocDetails(input: ICPCInputModel): Observable<any> {
        return this.restAPIService.new_POST(this.endPoints.insertCPCDocDetails, input);
    }

    public GetStandardDrawings(input: ISDInputModel): Observable<ISDOutputModel[]> {
        return this.restAPIService.new_POST(this.endPoints.getStandardDrawings, input);
    }
    public InsertStdDwgDocument(schBulkDoc: IScheduleBulkInsertModel) {
        return this.restAPIService.new_POST(this.endPoints.insertStdDwgDocument, schBulkDoc);
    }
    public LinkStdDciDoc(SDLinkListModel: SDLinkModel) {
        return this.restAPIService.new_POST(this.endPoints.linkStdDciDoc, SDLinkListModel);
    }

    public GetSDDocList(input: IPorjectInputModel): Observable<IDCIDocumentOutputModel[]> {
        return this.restAPIService.new_POST(this.endPoints.getSDDocList, input)
    }

    public InsertBulkISODCIDocuments(schBulkDoc: IScheduleBulkInsertModel[]) {
        return this.restAPIService.new_POST(this.endPoints.insertBulkISODCIDoc, schBulkDoc);
    }

    public UploadISOExcel(formData: FormData): Observable<any> {
        let _apiURL = environment.uriHost + this.endPoints.fetchISODCIDetails;
        const headers = {
            'X-Requested-With': 'XMLHttpRequest',
            'Authorization': 'Bearer ' + this.commonService.getJWT(),
            'loginAuditNumber': this.encryptDecryptService.decrypt(this.commonService.getLoginAuditNumber())
        }
        return this.http.post<any>(_apiURL, formData, { 'headers': headers });
    }

}
